// Dashboard.js
import React, { useRef, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import ReactEditList from "react-edit-list";
import { getDocs, collection, query, addDoc, orderBy, doc, deleteDoc, setDoc } from 'firebase/firestore/lite';
import {db} from './../firebase';
import { DASHBOARD_CRUD, notifyDashboardCrudError, failDashboardValidation, isBlank } from '../utils/dashboardCrud';
import FileUploader from './../FileUploader';

// Using native HTML5 drag and drop
import { useDragAndDrop } from './useDragAndDrop';

// This is the schema
const schema = [
  { name: "id", type: "id" },
  { name: "name", type: "string" },
  { name: "url_image", type: "custom" },
  { name: "enabled", type: [
      { value: true, name: "Si" },
      { value: false, name: "No" }
    ] 
  }
];

const headers = {
  "name"      : "Nombre",
  "url_image" : "Imagen",
  "enabled"   : "Mostrar"
};

export const GroupPhotosList = () => {

  const DOCUMENT_NAME = 'group-photos';
  
  const [data, setData] = useState([]);
  const dataRef = useRef([]);

  const navigate = useNavigate();

  const goToDashboard = async () => {
    navigate('/dashboard');
  };

  // Keep dataRef in sync with data state
  useEffect(() => {
    dataRef.current = data;
  }, [data]);

  const ref = useRef(null);
  const TITLE = 'Fotos Grupales';
  
  // Use drag and drop hook
  const { initDragAndDrop } = useDragAndDrop(data, setData, dataRef, DOCUMENT_NAME, TITLE, ref);

  const fetchData = async () => {
    try {
      const q = query(collection(db, DOCUMENT_NAME), orderBy('order'));
      const querySnapshot = await getDocs(q);
            const newData = querySnapshot.docs
                .map((doc) => ({ ...doc.data(), id:doc.id }));
            setData(newData);
            dataRef.current = newData;
      
      // Initialize drag and drop after data is loaded
      setTimeout(() => {
        initDragAndDrop();
      }, 1000);
    } catch (error) {
      notifyDashboardCrudError({ operation: DASHBOARD_CRUD.LOAD, entityName: TITLE, error });
      setData([]);
    }
    }

  useEffect(()=>{
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <div className="container-fluid mt-1">
        <div className="card shadow">
            <div className="card-header bg-primary text-white d-flex justify-content-between align-items-center">
                <button className="btn btn-danger" onClick={goToDashboard} >Regresar</button><h3 className="mb-0">Listado de Fotos Grupales</h3>
            </div>
            <div className="card-body">
                <div className="table-responsive">
                    <React.Fragment>
                      <div className="m-3 fw-bold">
                        Se pueden reordenar las fotos moviendolas de orden en la lista
                      </div>
                      <ReactEditList
                        schema={schema}
                        headers={headers}
                        onLoad={() => data}
                        ref={ref}
                        format={{
                          url_image: function UrlImgRenderer(props) {
                            if ( props.value )
                            {
                              return (
                                <div>
                                  <a href={props.value} target="_blank" rel="noopener noreferrer">Descargar</a>
                                  <div>
                                    <img src={props.value} alt="Archivo Subido" style={{ maxWidth: '20em', marginTop: '10px' }} />
                                  </div>
                                </div>
                              );
                            }
                            else
                            {
                              return null;
                            }
                          },
                        }}
                        edit={{
                          // You have to provide a custom editor that is a React component
                          // react-edit-list will pass you the current value in `props.value`
                          // In order to modify it, you will have to call `props.onChange()`
                          url_image: function UrlImagEditor(props) {
                            return (<FileUploader imageMaxWidth={'20em'} url={props.value} onUpload={(file)=>{
                              props.onChange(file);
                            }}/>);
                          }
                        }}
                        onUpdate={async (item) => {
                          // Call your API here
                          if (isBlank(item.name)) {
                            return failDashboardValidation({
                              operation: DASHBOARD_CRUD.UPDATE,
                              entityName: TITLE,
                              missingFields: ['Nombre'],
                              message: 'Debes capturar el nombre de la foto.',
                            });
                          }
                          item.enabled = item.enabled === 'false' || item.enabled === false ? false : true;
                          if (!item.url_image)
                          {
                            item.url_image = null;
                          }
                          try {
                            await setDoc(doc(db, DOCUMENT_NAME, item.id), item);
                          } catch (error) {
                            notifyDashboardCrudError({ operation: DASHBOARD_CRUD.UPDATE, entityName: TITLE, error });
                            return false;
                          }
                        }}
                        onDelete={async (item) => {
                          if (!window.confirm("Are you sure you want to delete it?")) return false;
                          try {
                            await deleteDoc(doc(db, DOCUMENT_NAME, item.id));
                          } catch (error) {
                            notifyDashboardCrudError({ operation: DASHBOARD_CRUD.DELETE, entityName: TITLE, error });
                            return false;
                          }
                        }}
                        onInsert={ async (item) => {
                          // Call your API here
                          if (isBlank(item.name)) {
                            return failDashboardValidation({
                              operation: DASHBOARD_CRUD.CREATE,
                              entityName: TITLE,
                              missingFields: ['Nombre'],
                              message: 'Debes capturar el nombre de la foto grupal.',
                            });
                          }
                          if (!item.url_image)
                          {
                            item.url_image = null;
                          }
                          item.enabled = item.enabled === 'false' || item.enabled === false ? false : true;
                          item.order = data.length;
                          try {
                            const docRef = await addDoc(collection(db, DOCUMENT_NAME), item);
                            item.id = docRef.id;
                          } catch (error) {
                            notifyDashboardCrudError({ operation: DASHBOARD_CRUD.CREATE, entityName: TITLE, error });
                            return false;
                          }
                        }}
                        className="table table-light table-fixed align-middle"
                        headClassName="table-primary"
                        inputClassName="w-100"
                        thClassName={{
                          // These allow to fix the column widths
                          name: "col-3",
                          url_imagen: "col-8",
                          buttons: "col-1",
                        }}
                        bodyClassName="sortable-items"
                        btnValidateClassName="btn btn-success p-0 m-0"
                        btnDeleteClassName="btn btn-danger py-0 px-1 m-0 mx-1"
                        btnCancelClassName="btn btn-secondary py-0 px-1 m-0 mx-1"
                        rowClassName="draggable"
                        insertClassName="not-draggable"
                        filler={<React.Fragment>&#8230;</React.Fragment>}
                      />
                    </React.Fragment>
                </div>
            </div>
        </div>
    </div>
  );
}
